import api from '../../utils/api';
import store from '../index';
import authStore from './auth';

const state = {
	paymentLinkData: null,
	message: null,
	creditDirectUserEmail: null,
	amountToPassToCreditDirect: 0,
	cdlTransactionReference: null
};

const getters = {
	getMessage: (state) => state.message,
	getCreditDirectUserEmail: (state) => state.creditDirectUserEmail,
	getAmountToPassToCreditDirect: (state) => state.amountToPassToCreditDirect,
	getCdlTransactionReference: (state) => state.cdlTransactionReference
};

const mutations = {
	setMessage: (state, data) => {
		state.message = data;
	},
	setCreditDirectUserEmail: (state, data) => {
		state.creditDirectUserEmail = data;
	},
	setAmountToPassToCreditDirect: (state, data) => {
		state.amountToPassToCreditDirect = data;
	},
	setCdlTransactionReference: (state, data) => {
		state.cdlTransactionReference = data;
	}
};

const actions = {
	async creditDirectFetchApi({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api.get(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				commit('addPreviousModal', store.state.nextModal);
				commit('setNextModal', response.next_step);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async creditDirectPostApi({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api.post(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				if (response?.data?.token) {
					commit('updateToken', response?.data?.token);
				}
				if (!store.state.userPartnerToken) {
					const token = response && response.data && response.data.token ? response.data.token : null;
					await commit('setUserPartnerToken', token);
				}
				if (response.next_step.name === 'NEW_LOAN') {
					const email = typeof response?.data?.user !== 'undefined' ? response?.data?.user?.email : response?.data?.email;
					commit('setCreditDirectUserEmail', email);
				}
				if (response.next_step.name === 'REDIRECT') {
					commit('setAmountToPassToCreditDirect', (parseInt(response?.data?.amount, 10)));
					commit('setCdlTransactionReference', response.data.reference);
				}
				if (response.message.includes('exists')) {
					await commit('setNewUser', true);
				}
				commit('addPreviousModal', store.state.nextModal);
				commit('setNextModal', response.next_step);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async queryCreditDirectTransactionStatusApi({ commit, dispatch }, data) {
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api.get(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setQueryTransactionStatus', response.message);
				if (response.is_completed) {
					commit('setIsLoading', false);
					commit('setNextModal', response.next_step);
					if (response.success) {
						commit('setIframeResponseOnSuccess', {
							status: true,
							type: 'SUCCESS',
							data: {
								status: 'successful',
								data: {
									reference: response.transaction.reference,
									redirect_url: authStore.state.payload.redirect_url
										? authStore.state.payload.redirect_url
										: false
								}
							}
						});
					} else {
						commit('setIframeResponseOnError', {
							message: response.message,
							type: 'ERROR'
						});
					}
				}
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	}
};

export default {
	state,
	getters,
	mutations,
	actions
};
